import {Box, Button, CssBaseline, Typography} from '@mui/material';
import {alpha} from '@mui/material/styles';
import Sidebar from '../layout/Sidebar';
import Topbar from '../layout/Topbar';
import React from 'react';
import {CustomMainRootBox} from '../dashboard/Dashboard';
import {useHistory} from 'react-router-dom';
import DomainsTable from './DomainsTable';
import BucketsTable from './buckets/BucketsTable';
import DeploymentsTable from './deployments/DeploymentsTable';
import {getSettingsColors, settingsTabButtonStyles} from '../settings/SettingsDesign';

const sections = [
    {path: '/websites/domains', label: 'Domains', Component: DomainsTable},
    {path: '/websites/s3-buckets', label: 'S3 Buckets', Component: BucketsTable},
    {path: '/websites/deployments', label: 'Deployments', Component: DeploymentsTable}
];

export function WebsiteTabs({pathname}) {
    const history = useHistory();
    const activeIndex = Math.max(0, sections.findIndex(section => pathname === section.path));
    const handleKeyDown = (event, index) => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % sections.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + sections.length) % sections.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = sections.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        event.currentTarget.parentElement.querySelectorAll('[role="tab"]')[next].focus();
        history.push(sections[next].path);
    };
    return <Box role="tablist" aria-label="Website management" sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5, p: 0.5, mb: 3,
        bgcolor: theme => getSettingsColors(theme).card, borderRadius: '10px', width: 'fit-content', maxWidth: '100%'}}>
        {sections.map((section, index) => <Button key={section.path} role="tab" id={`website-tab-${index}`}
            aria-selected={activeIndex === index} aria-controls={`website-panel-${index}`} tabIndex={activeIndex === index ? 0 : -1}
            color="inherit" onClick={() => history.push(section.path)} onKeyDown={event => handleKeyDown(event, index)}
            sx={{...settingsTabButtonStyles, bgcolor: activeIndex === index ? theme => alpha(theme.palette.primary.main, 0.1) : 'transparent',
                color: activeIndex === index ? 'primary.main' : 'text.secondary'}}>{section.label}</Button>)}
    </Box>;
}

function Websites({location, ...props}) {
    const activeIndex = sections.findIndex(section => location?.pathname === section.path);
    const ActiveTable = sections[activeIndex]?.Component;
    return <CustomMainRootBox>
        <CssBaseline/>
        <Topbar/>
        <Sidebar {...props}/>
        <Box component="main" sx={{height: '100dvh', flex: 1, minWidth: 0, overflow: 'auto', pt: '49px',
            borderLeft: '1px solid', borderColor: 'divider', bgcolor: theme => getSettingsColors(theme).canvas}}>
            <Box sx={{maxWidth: 1280, mx: 'auto', minWidth: 0, px: {xs: 2, md: 3.75}, pt: 3, pb: 4,
                '& .MuiTypography-root': {whiteSpace: 'normal'}, '& .MuiButton-root': {boxShadow: 'none', textTransform: 'none', borderRadius: '8px'}}}>
                <Typography component="h1" sx={{fontSize: {xs: 24, md: 28}, fontWeight: 700, letterSpacing: '-0.5px'}}>Websites</Typography>
                <Typography sx={{fontSize: 14, color: 'text.secondary', mt: 0.75, mb: 3}}>Manage your domains, website files, and deployments.</Typography>
                <WebsiteTabs pathname={location?.pathname}/>
                {ActiveTable && <Box role="tabpanel" id={`website-panel-${activeIndex}`} aria-labelledby={`website-tab-${activeIndex}`}><ActiveTable/></Box>}
            </Box>
        </Box>
    </CustomMainRootBox>;
}

export default Websites;
